import React from "react";
import { Badge } from "flowbite-react";
import type { ArticleProduct } from "@/domains/articles/ArticleProduct";
import { Shop } from "@/domains/cats/Food";
import { SPONSORED_LINK_REL } from "@/lib/LinkRel";

const SHOP_LINK_LABELS: Record<Shop, string> = {
  [Shop.Rakuten]: "楽天市場で見る",
  [Shop.Amazon]: "Amazonで見る",
};

const fetchedAtDateFormatter = new Intl.DateTimeFormat("ja-JP", {
  year: "numeric",
  month: "numeric",
  day: "numeric",
  timeZone: "Asia/Tokyo",
});

const formatFetchedAtDate = (fetchedAt: string): string =>
  fetchedAtDateFormatter.format(new Date(fetchedAt));

export const ArticleProductCard: React.FC<{ product: ArticleProduct }> = ({
  product,
}) => {
  return (
    <div className="my-6 rounded-2xl border border-primary-100 bg-white p-4 shadow-sm sm:flex sm:items-center sm:gap-4">
      <img
        src={product.imageUrl}
        alt={product.name}
        loading="lazy"
        referrerPolicy="no-referrer"
        className="h-24 w-24 rounded-lg bg-primary-50 object-contain"
      />
      <div className="mt-3 min-w-0 flex-1 sm:mt-0">
        <Badge color="gray" size="xs">
          PR
        </Badge>
        <p className="mt-1 font-bold text-primary-800">{product.name}</p>
        <p className="text-xs text-primary-500">{product.brand}</p>
        {product.price !== undefined ? (
          <p className="mt-1 text-xs text-primary-500">
            ¥{product.price.amount.toLocaleString("ja-JP")}（
            {formatFetchedAtDate(product.price.fetchedAt)}時点）
          </p>
        ) : (
          <p className="mt-1 text-xs text-primary-500">
            価格は商品ページで確認してください
          </p>
        )}
        <div className="mt-3 flex flex-wrap gap-2">
          {product.links.map((link) => (
            <a
              key={link.shop}
              href={link.url}
              target="_blank"
              rel={SPONSORED_LINK_REL}
              className="rounded-full border border-primary-300 px-3 py-1 text-sm text-primary-700 hover:bg-primary-50"
            >
              {SHOP_LINK_LABELS[link.shop]}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};
